export const TEST_USER = [
	'test@satschel.com',
	'performance@satschel.com',
	'it@satschel.com',
];

/**
 * The 400 message `authenticateOpts` answers with when the account has no
 * passkey at all — from clients.api `web-authn.getAuthenticateOptions`
 * (`ErrorCodes.noDevices`) and users.api `WebAuthn.getAuthenticateOptions`
 * (`ErrorCodes.noDevice`), both spelled exactly like this. It is the one
 * expected error on that call: the "set up a passkey" card is its UI, and it
 * must not also surface as a toast.
 */
export const NO_DEVICE_MESSAGE = 'No device registered';
